<div
  class="slider-item"
  (click)="click(image.inspection.id)"
  *ngIf="image.inspection"
  [style.background-image]="'url(' + image.inspection.preview + ')'"
  (error)="setDefaultImage($event)"
>
  <!-- <div class="wrapper"> -->
  <div
    class="opacity-div"
    [ngClass]="{ 'failed-model': image.inspection.inspection_status_id === 2 }"
  ></div>

  <div class="model">
    <div class="model-name">{{ image.inspection.name | split: 20 }}</div>

    <div class="line"></div>
    <div class="gallery-item-user-info-container">
      <img
        [src]="image.inspection.user.avatar"
        class="user-photo"
        (error)="setDefaultAvatar($event)"
      />
      <div class="gallery-item-user-info-text">
        {{ image.inspection.user.name }} {{ image.inspection.user.surname }}
      </div>
    </div>
  </div>
</div>
